import {
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import ErrorBoundary from "components/ErrorBoundary";
import { AnimatePresence } from "framer-motion";
import { ConfirmProvider } from "material-ui-confirm";
import { SnackbarProvider } from "notistack";
import { ActionLayout } from "pages/ActionLayout";
import { AutoCompleteAddressTest } from "pages/AddressTest";
import { Booking, chatAttachmentState, openChatState, SUPPORT_CHAT } from "pages/CustomerBooking";
import ExternalHealthScreening from "pages/HealthScreening/externalHealthScreening";
import ClientScreening from "pages/ClientScreening";
import ClientIvPathway from "pages/ClientIvPathway";
import { NotFound } from "pages/NotFound";
import { ParticleLanding } from "pages/ParticleLand";
import Qrcode from "qrcode.react";
import QueryString from "qs";
import React, { useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { Versioning } from "util/versioning";
import { useBranch } from '@zennya/web-component-library/src/components/BranchIO/BranchProvider'
import "./App.css";
import { toast, ToastBar, Toaster } from "react-hot-toast";
import { useRecoilState, useSetRecoilState } from "recoil";
import { CustomToaster } from "components/CustomToaster";
import { CustomerBookingCreate } from "pages/CustomerBookingCreate";
import { useListenForAccess } from "util/windowUtils";
import { LinkGenerator } from "pages/CustomerBookingCreate/LinkGenerator";
import { fingerprintState } from "util/deviceUUID";
import isEmpty from "lodash.isempty";
import { v4 as uuidv4 } from "uuid";
import { Interceptor } from "util/interceptor";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    flexGrow: 1,
    backgroundColor: theme.palette.error.main,
    [theme.breakpoints.up("sm")]: {
      flexGrow: "initial",
      minWidth: 344,
    },
  },
  title: {
    color: theme.palette.error.contrastText,
  },
  face: {
    position: "absolute",
    backfaceVisibility: "hidden",
    display: "grid",
    placeItems: "center",
    width: "100%",
    height: "100%",
  },
  front: {
    background: "white",
  },
  rear: {
    background: "white",
    transform: "rotateY(180deg)",
  },
  centerQR: {
    // backgroundColor: '#fff'
  },
}));

const SnackQR = React.forwardRef(({ id, message, onClickDismiss }, ref) => {
  const classes = useStyles();
  const q = QueryString.parse(message?.code?.search);
  const newQs = {
    code: q?.code,
    path: message?.code?.pathname,
    type: message?.type,
  };
  return (
    <Card className={classes.card} ref={ref}>
      <CardHeader
        subheader={message?.message}
        classes={{
          subheader: classes.title,
        }}
        action={
          <IconButton
            className={classes.title}
            onClick={() => onClickDismiss(id)}
          >
            <Cancel />
          </IconButton>
        }
      />
      {/* <CardContent className={classes.centerQR}>
        <Qrcode value={JSON.stringify(newQs)} renderAs="svg" size={256} />;
      </CardContent> */}
    </Card>
  );
});

const App = () => {
  const notistackRef = React.createRef();

  const BRANCH_API_KEY = process.env.REACT_APP_BRANCH_API_KEY

  const location = useLocation();
  const storage = useListenForAccess()

  const [fingerprint, setFingerprint]= useRecoilState(fingerprintState);

  useEffect(
    () => {
      if (isEmpty(fingerprint) || fingerprint?.toLowerCase() === 'null' || fingerprint?.toLowerCase() === 'undefined') {
        setFingerprint(uuidv4())
      }
    }, []
  );
  return (
    <SnackbarProvider
      maxSnack={3}
      ref={notistackRef}
      content={(key, message, a, b) => {
        return (
          <SnackQR
            id={key}
            message={message}
            onClickDismiss={(k) => notistackRef.current.closeSnackbar(k)}
          />
        );
      }}
      action={(key) => (
        <Button
          variant="text"
          color="inherit"
          onClick={() => (k) => notistackRef.current.closeSnackbar(key)}
        >
          Dismiss
        </Button>
      )}
    >

      <ConfirmProvider>
        {/* <Versioning /> */}
        <ErrorBoundary location={location}>
          <AnimatePresence exitBeforeEnter initial>
            <Switch
              location={location}
              key={location.pathname}
            >

              <Route exact path="/">
                <ParticleLanding />
              </Route>
              <Route exact path="/invites">
                <ActionLayout />
              </Route>
              <Route path="/onboarding">
                <ActionLayout />
              </Route>
              <Route path="/health-screening/">
                <ExternalHealthScreening />
              </Route>
              <Route path="/bookings">
                <Booking />
              </Route>
              <Route path="/createbooking">
                <Interceptor quiet/>
                <CustomerBookingCreate />
              </Route>
              <Route path="/linkgenerator">
                <LinkGenerator />
              </Route>
              <Route path="/client-screening">
                {/* Registers the global axios X-Auth-Token interceptor (from
                    localStorage['user'].token), same as /createbooking. Required
                    because clientLogin's post-login getPersonalInfo uses bare
                    axios — without this, a direct load 403s the profile fetch. */}
                <Interceptor quiet />
                <ClientScreening />
              </Route>
              <Route path="/client-iv">
                {/* Same as /client-screening: mount the axios X-Auth-Token
                    interceptor so the client IV pathway's authed calls carry
                    the token on a direct load. */}
                <Interceptor quiet />
                <ClientIvPathway />
              </Route>
              <Route>
                <NotFound />
              </Route>
            </Switch>
          </AnimatePresence>
        </ErrorBoundary>
      </ConfirmProvider>
    </SnackbarProvider>
    

  );
};
export default App;
